import { useCallback, useRef, useState } from "react";
import { TableSessionsFetchAPI } from "../../api/TableSessions";
import AlertSmall from "../Alerts/AlertSmall";
import ErrorAlert from "../Alerts/ErrorAlert";

// Owned by the modal, so collapsing a preview does not discard session status.
export default function useOnlinePaymentAuthorization() {
    const statusesRef = useRef({});
    const [statuses, setStatuses] = useState({});

    const authorize = useCallback(async (sessionUuid) => {
        if (!sessionUuid || statusesRef.current[sessionUuid]) return;
        const update = (status) => {
            const next = { ...statusesRef.current };
            if (status) next[sessionUuid] = status;
            else delete next[sessionUuid];
            statusesRef.current = next;
            setStatuses(next);
        };

        update("pending");
        try {
            await TableSessionsFetchAPI.authorizePayment(sessionUuid, localStorage.getItem("x-access-machine-token"));
            update("authorized");
            AlertSmall("El cliente ya puede pagar desde su celular", "success");
        } catch (err) {
            update(null);
            console.error(err);
            ErrorAlert("", "No fue posible habilitar el pago en linea", "error");
        }
    }, []);

    return { statuses, authorize };
}
